import { AppBar, Toolbar, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import FooterLinks from './Links/FooterLinks'
import styles from './footer.module.scss'

const currentYear = new Date().getFullYear()

export const Footer = () => {
  return (
    <AppBar
      component="footer"
      position="static"
      className={styles.styledAppBar}
    >
      <Toolbar className={styles.styledRoot}>
        <Grid
          container
          className={styles.styledContainer}
          gap={{ xs: 3, sm: 0 }}
          alignItems="center"
        >
          <Grid item xs={12} sm={6}>
            <Grid
              container
              sx={{ justifyContent: { sm: 'left', xs: 'center' } }}
            >
              <FooterLinks />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid
              container
              sx={{ justifyContent: { sm: 'right', xs: 'center' } }}
            >
              <Typography>&copy; {currentYear} Target Brands, Inc.</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  )
}

export default Footer
